

import OBQQuestions from './obq-questions.value';
import OBQService from './obq.service';

export const moduleName = 'OBQ';

angular.module(moduleName, [])
  .value('OBQQuestions', OBQQuestions)
  .service('OBQService', OBQService);

export default {
  moduleName,
};